<template>
  <nav class="snav" aria-label="Sections des paramètres">
    <router-link
      v-for="item in items"
      :key="item.to"
      :to="item.to"
      class="snav-link"
      active-class=""
      exact-active-class="is-active"
    >
      <i :class="item.icon" aria-hidden="true"></i>
      <span>{{ item.label }}</span>
    </router-link>
  </nav>
</template>

<script lang="ts">
import { defineComponent } from "vue";

// Shared navigation of the settings pages (same routes as before).
export default defineComponent({
  name: "SettingsNav",
  setup() {
    const items = [
      { to: "/account-settings", label: "Général", icon: "ph ph-buildings" },
      { to: "/settings-statuts", label: "Statuts", icon: "ph ph-flag" },
      { to: "/settings-type-clients", label: "Types de clients", icon: "ph ph-users-three" },
      { to: "/settings-banks", label: "Banques", icon: "ph ph-bank" },
      { to: "/settings-delivery-providers", label: "Prestataires", icon: "ph ph-plugs-connected" },
    ];
    return { items };
  },
});
</script>

<style scoped>
.snav {
  display: flex;
  gap: 6px;
  margin-bottom: var(--ui-space-5);
  padding: 5px;
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-pill);
  background: var(--ui-surface);
  box-shadow: var(--ui-shadow-card);
  overflow-x: auto;
  scrollbar-width: none;
}
.snav::-webkit-scrollbar {
  display: none;
}
.snav-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
  padding: 9px 16px;
  border-radius: var(--ui-radius-pill);
  color: var(--ui-text-secondary);
  font-size: var(--ui-fs-sm);
  font-weight: var(--ui-fw-bold);
  text-decoration: none;
  white-space: nowrap;
  transition: background-color var(--ui-dur-fast) var(--ui-ease), color var(--ui-dur-fast) var(--ui-ease),
    box-shadow var(--ui-dur-fast) var(--ui-ease);
}
.snav-link i {
  font-size: 17px;
}
.snav-link:hover {
  background: var(--ui-accent-soft);
  color: var(--ui-accent-text);
}
.snav-link.is-active {
  background: var(--ui-accent);
  color: #ffffff;
  box-shadow: 0 6px 16px rgba(var(--ui-accent-rgb), 0.28);
}
</style>
